import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ModalPopup from '../components/common/ModalPopup';
import Style from './SocIntegration.module.css';
import socApisCA from '../components/data/socApisCA.json'
import socApisTA from '../components/data/socApisTA.json'
import SocDetails from './SocDetails';
import SOCHeader from './SOCHeader';
class SocIntegration extends Component {

    constructor(props) {
        super(props);
        this.state = {
            socApis: this.props.tokenRoles === "TenantAdmin"? socApisTA : socApisCA,
            selectedApi: this.props.tokenRoles === "TenantAdmin"? socApisTA[0].tabName : socApisCA[0].tabName
        };
    }

    componentDidMount = () => {
        if (this.props.selectedCustomer) {
            this.setjson();
        } 
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.selectedCustomer !== prevProps.selectedCustomer) {
            this.setjson();
        }
    }

    handleClick = (tab) => {
        this.setState({
          selectedApi: tab,
        })
    }

    fetchCurrentDateDetails = () =>{
        var priorDate = new Date();
        priorDate.setDate(priorDate.getDate() - 30);
        var priorDateString = priorDate.toISOString().split('T')[0];
        var today = new Date();
        var todayString = today.toISOString().split('T')[0];
        return { priorDateString, todayString };
    }

    setjson = () =>{
        const baseApis = this.props.tokenRoles === "TenantAdmin" ? socApisTA : socApisCA;
        let filteredApis = baseApis.filter(item => item.tabName !== "Threat Intelligence");

        let jsonString = JSON.stringify(filteredApis);
        let { priorDateString, todayString } = this.fetchCurrentDateDetails();
        const baseUrl = process.env.REACT_APP_API_BASE_URL;

        // Replace certain values
        jsonString = jsonString.replaceAll('{priorDateString}', priorDateString); 
        jsonString = jsonString.replaceAll('{todayString}', todayString); 
        jsonString = jsonString.replaceAll('{baseUrl}', baseUrl); 


        // Convert back to JSON object
        const modifiedJSON = JSON.parse(jsonString);
        this.setState({
            socApis: modifiedJSON,
            selectedApi: modifiedJSON[0].tabName
          })
    }


    render() {
        if (!this.props.selectedCustomer)
            return null;

        return (
            <div  className={`Container`}
              style={{
                padding: '0 1.8% 0 2.4%',
                margin: '0 0 0 43px',
              }}>
                <SOCHeader 
                    title="SOC Integration"
                    description={
                        <>
                        The above API key is your organization's private API key and should not be shared with anyone outside your organization.<br/>
                        Your API key allows you to fetch your required data in JSON format using the SOC API.<br/>
                        {this.props.tokenRoles === "TenantAdmin" ? 'A global API key fetches the incident data of all customers.' : ''}
                        The response can be filtered using optional query string parameters. The format and the default values of the parameters are listed below.
                        </>
                    }
                    showGlobalKey={this.props.tokenRoles === "TenantAdmin"}
                    showCustomerKey={true}
                />
                <div>
                    <div className={`${Style.navbar} ${Style.boxShadow} pl-4 d-flex mt-4 mb-2`}>
                        {this.state.socApis
                            .map((socApi, index)=>
                            <div 
                                key={socApi.tabId}
                                onClick={() => this.handleClick(socApi.tabName)}
                                className={`${
                                this.state.selectedApi === socApi.tabName
                                    ? `${Style.navbarSelectedItemStyle} d-flex align-items-center`
                                    : `${Style.navbarFontStyle} d-flex align-items-center`
                                }`}
                                style={{ marginRight: '20px', fontSize: '14px' }}
                            >
                                {socApi.tabName}
                            </div>)
                            }
                    </div>
                </div>
                
                <SocDetails apiData={this.state.socApis.filter((socApi)=>socApi.tabName === this.state.selectedApi)[0]}/>

                {this.props.statusCode && <ModalPopup statusCode={this.props.statusCode} msg={this.props.userMsg} />}
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    loading: state.entities.customers.loading,
    apiKey: state.entities.customers.apiKey,
    selectedCustomer: state.entities.customers.selected,
    tokenRoles: state.entities.user.roles,
    licenseType: state.entities.customers.selected?.licenseType
})

const mapDispatchToProps = (dispatch) => ({
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SocIntegration))